import { JSX, Show, Suspense } from "solid-js";
import { createAsync, query } from "@solidjs/router";
import { getViewData, ViewData } from "./data/view_data";
import { useView } from "./hooks/use_view";
import { ViewProvider } from "./data/view_context";
import { VoucherCard } from "./fragments/voucher_card";
import { FullScreenLoaderTelescope } from "~/components/webstore_telescope/full_screen_loader";
import { BottomBranding$Client } from "~/components/partner_components/partner_bottom_page_branding";
import { useWebStoreContext } from "~/context/webstore_context";
import { BackgroundGradientV2 } from "~/components/webstore/background_gradient_v2";

const CACHE_KEY = "home_indriya_view_data";
const getData = query(getViewData, CACHE_KEY);

export default function HomeIndriyaView(props: {
  offerText: string;
  tncs: string[];
}): JSX.Element {
  const viewData = createAsync(() => getData(), {
    deferStream: true,
  });

  return (
    <Suspense fallback={<FullScreenLoaderTelescope />}>
      <Show when={viewData()}>
        <_HomeIndriyaView
          viewData={viewData()!}
          offerText={props.offerText}
          tncs={props.tncs}
        />
      </Show>
    </Suspense>
  );
}

function _HomeIndriyaView(props: {
  viewData: ViewData;
  offerText: string;
  tncs: string[];
}): JSX.Element {
  const viewState = useView(props.viewData);
  const { getClientId, getPartnerConfigV3 } = useWebStoreContext();

  return (
    <ViewProvider value={viewState}>
      <div class="flex h-full min-h-dvh w-full flex-col items-center justify-center px-4">
        <Show when={getPartnerConfigV3().showGradient}>
          <BackgroundGradientV2
            color={getPartnerConfigV3().gradientColor ?? "#001EFF"}
          />
        </Show>

        <VoucherCard offerText={props.offerText} tncs={props.tncs} />
        <div class="mt-[80px]" />
        <BottomBranding$Client clientId={getClientId} />
      </div>
    </ViewProvider>
  );
}
